import script from "./GroupIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupIcon.vue?vue&type=script&setup=true&lang=js"

import "./GroupIcon.vue?vue&type=style&index=0&id=34caa9fb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34caa9fb"]])

export default __exports__